import { createAction } from 'redux-actions';
import WixSDK from 'shared/utils/wix-sdk';

import { getCompId } from 'shared/utils/comp-id';
import { updateCSS } from 'shared/utils/update-css';


export const APP_SETTINGS_UPDATE = 'CLIENT.APP_SETTINGS.SET';

export const updateAppSettings = createAction(APP_SETTINGS_UPDATE);

export const fetchAppSettings = () => dispatch => {
  const compId = getCompId();

  return Promise.all([
      WixSDK.Styles.getStyleParams(),
      WixSDK.Settings.getSiteInfo(),
      WixSDK.getCurrentPageId(),
    ])
    .then(([styles, { url }, sitePageId]) => {
      updateCSS(styles);

      dispatch(updateAppSettings({
        ...styles,
        compId,
        sitePageId,
        siteUrl: url,
        instance: WixSDK.Utils.getInstance(),
        instanceId: WixSDK.Utils.getInstanceId(),
        editMode: WixSDK.Utils.getViewMode(),
      }));

      return styles;
    });
};



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/app-settings.js